import React from 'react';
import { UniversalLink } from '@plone/volto/components';
import moment from 'moment';

const TermineListingTemplate = ({ items = [] }) => {
  return (
    <div className="termine-listing">
      {items.map((item) => (
        <article key={item['@id']} className="termin-item">

          <div className="termin-date-box">
            <div className="day">
              {item.start ? moment(item.start).format('DD') : ''}
            </div>
            <div className="month-year">
              <span className="month">
                {item.start ? moment(item.start).format('MMM') : ''}
              </span>
              <span className="year">
                {item.start ? moment(item.start).format('YYYY') : ''}
              </span>
            </div>
            <div className="time">
              {item.start ? moment(item.start).format('HH:mm') : ''}
            </div>
          </div>

          <div className="termin-content">
            <h3 className="termin-title">
              <UniversalLink href={item['@id']}>
                {item.title}
              </UniversalLink>
            </h3>
            {item.description && (
              <div className="termin-description">{item.description}</div>
            )}
            {item.location && (
              <div className="termin-location">{item.location}</div>
            )}
          </div>
        </article>
      ))}
    </div>
  );
};

export default TermineListingTemplate;